var _style, _rect, _defs, _path, _polyline, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 200",
    style: {
      enableBackground: "new 0 0 350 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#231F20;}\r\n\t.st1{clip-path:url(#XMLID_8_);fill:#FBD50A;}\r\n\t.st2{clip-path:url(#XMLID_8_);fill:none;stroke:#FFFFFF;stroke-width:5.029;stroke-miterlimit:10;}\r\n\t.st3{clip-path:url(#XMLID_8_);fill:none;stroke:#FFFFFF;stroke-width:4.408;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{font-family:'Bebas';}\r\n\t.st6{font-size:38.6325px;}\r\n\t.st7{letter-spacing:3;}\r\n\t.st8{letter-spacing:2;}\r\n\t.st9{letter-spacing:-2;}\r\n\t.st10{letter-spacing:1;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1_",
    x: -2.5,
    className: "st0",
    width: 352.5,
    height: 200
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: -147.8,
    y: -275.9,
    width: 691.2,
    height: 680.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M255.5,40.2h17.2v-6.5l-8.6-2.6l-2.1-4.9l4.4-7.9l-7.4-7.4l-7.9,4.4l-5.2-2.1l-2.4-8.7h-10.8 l-2.3,8.4l-5,2.4l-7.8-4.3l-7.4,7.1l4.1,8.1l-1.8,5l-8.2,2.1v6.8h17.3c0,0-0.5-16.9,16.9-16.7C255.8,23.7,255.5,40.2,255.5,40.2"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_2_",
    className: "st2",
    points: "306.3,96.8 306.3,96.8 40.2,96.8  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st3",
    d: "M39.5,155.6c0,0,7.8,15.7,20.3,24.1c12.6,8.3,34.5,14.3,34.5,14.3s19.4-18.2,37.1-18.2 c17.8,0,40.5,4.7,56.2,6.1c15.7,1.4,15.7,1.4,21.6-1.7c14.2-7.5,24.7-15.1,39.4-24.4c14.8-9.3,35.3-20.2,40-24.5 c0,0,5.1-3.3,1.7-8.2c-2.1-3.1-9.2-3.4-18.7-1.4c-7.7,1.6-46.5,18.2-46.5,18.2s2.1,6.3-2.8,10.6c-4.9,4.4-12.7,7.1-29,5 c-16.4-2.1-30.2-9.8-30.2-9.8s15.4,2.9,25.4,3.1c9.9,0.2,11,1,20.5,0c8.4-0.9,11-5,8.4-9.7c-2.5-4.6-10.9-6.3-18.2-7.4 c-7.3-1-5.5-0.9-18.8-4.8c-16.7-4.9-32-13.2-41.4-13.2c-12,0-20.2,5.6-38.7,15C80.4,138.5,39.5,155.6,39.5,155.6z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "XMLID_4_",
    transform: "matrix(1 0 0 1 40.499 86.4912)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st4 st5 st6 st7"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.3,
    y: 0,
    className: "st4 st5 st6 st8"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.8,
    y: 0,
    className: "st4 st5 st6 st7"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.3,
    y: 0,
    className: "st4 st5 st6 st7"
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 97.8,
    y: 0,
    className: "st4 st5 st6 st9"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 117.2,
    y: 0,
    className: "st4 st5 st6 st7"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.1,
    y: 0,
    className: "st4 st5 st6 st8"
  }, "LET"), /*#__PURE__*/React.createElement("tspan", {
    x: 208,
    y: 0,
    className: "st4 st5 st6 st8"
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 218.5,
    y: 0,
    className: "st4 st5 st6 st10"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.8,
    y: 0,
    className: "st4 st5 st6"
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3d3bc9668dcfc4433135fa812da6585.svg";
export { ForwardRef as ReactComponent };